import { routerReducer, RouterReducerState } from '@ngrx/router-store';
import { ActionReducerMap, MetaReducer } from '@ngrx/store';
import { storeFreeze } from 'ngrx-store-freeze';
import { environment } from './../../../src/environments/environment';
import { debug } from './meta-reducers/debug.reducer';
import { RouterStateUrl } from './router/router.state';

export const metaReducers: MetaReducer<AppState>[] = [];

if (!environment.production) {
    metaReducers.unshift(storeFreeze);
    metaReducers.unshift(debug);
}

export const reducers: ActionReducerMap<AppState> = {
    router: routerReducer,
};

export interface AppState {
    router: RouterReducerState<RouterStateUrl>;
}
